import { autoinject, computedFrom, observable } from "aurelia-framework";
import { MeasuresAdminService, IMeasureVM, MeasureVM } from "../measures-admin-service";
import { includes, isObject } from "lodash";
import { AppSettings } from "../../../../utils/appsettings";
import { translate } from "../../../../utils/translator";



@autoinject
export class MeasuresList {
	measures: MeasureVM[];

	@observable nameFilter: string;
	// @observable specifierFilter: string;
	@observable codeFilter: string;

	@computedFrom('nameFilter', 'codeFilter')
	get visibleMeasures(): MeasureVM[] {
		return this.measures.filter(measure => this.isMeasureVisible(measure));
	}

	constructor(private service: MeasuresAdminService) {}

	async activate() {
		this.measures = (await this.service.getMeasures()).map(measure => new MeasureVM(measure));
	}

	private applyFilter(field: any, filter: string) {
		const value = isObject(field) 
			? field[AppSettings.lang] 
			: (field || '');

		return filter && filter.length 
			? includes(value.toLowerCase(), filter.toLowerCase())
			: true;
	}

	private isMeasureVisible(measure: MeasureVM) {
		return this.applyFilter(measure.nameWithSpecifier, this.nameFilter)
			&& this.applyFilter(measure.code, this.codeFilter);
	}
}
